// extracted by mini-css-extract-plugin
module.exports = {"secondaryButton":"SecondaryButton_secondaryButton__i8Vbj"};